import { useSelector } from 'react-redux';
import { RootState } from '../types/graph';

export const useMode = () =>
  useSelector((state: RootState) => state.graph.mode);

export const useWaitingRoom = () => {
  const mode = useMode();
  return mode === 'SALLE_ATTENTE';
};
